import { cn } from "@/lib/utils";
import { Reveal } from "./Reveal";

export interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  highlight?: string;
  align?: "start" | "center";
  className?: string;
  animated?: boolean;
}

function HighlightedHeading({ title, highlight }: { title: string; highlight?: string }) {
  const word = highlight ?? "";
  const index = word ? title.indexOf(word) : -1;
  if (!word || index === -1) return <>{title}</>;
  return (
    <>
      {title.slice(0, index)}
      <span className="home-highlight">{word}</span>
      {title.slice(index + word.length)}
    </>
  );
}

export function SectionHeader({
  eyebrow,
  title,
  highlight,
  align = "start",
  className,
  animated = false,
}: SectionHeaderProps) {
  const centered = align === "center";
  const pill = (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-home-pill border-[1.5px] border-home-navy px-4 py-2 text-[15px] font-semibold uppercase tracking-[0.04em] text-home-navy",
        centered && "mx-auto",
      )}
    >
      <span
        aria-hidden="true"
        className="h-2 w-2 shrink-0 rounded-full bg-home-accent animate-home-blink motion-reduce:animate-none"
      />
      {eyebrow}
    </span>
  );
  const heading = (
    <h2 className="mt-5 text-balance text-[clamp(36px,4.8vw,64px)] font-bold leading-[1.04] tracking-[-0.02em] text-home-navy">
      <HighlightedHeading title={title} highlight={highlight} />
    </h2>
  );

  return (
    <div className={cn(centered ? "text-center" : "text-left", className)}>
      {animated ? <Reveal>{pill}</Reveal> : pill}
      {animated ? <Reveal delay={100}>{heading}</Reveal> : heading}
    </div>
  );
}
